/* global grecaptcha */
import { injectScript, kebabToCamel } from 'js/tools';

export default class Recaptcha {
    /**
     * @param {HTMLFormElement} formNode
     * @param {string} siteKey
     */
    constructor(formNode, siteKey, actionName = null) {
        this.formNode = formNode;
        this.siteKey = siteKey;
        this.actionName = actionName;

        if (!this.formNode || !this.siteKey) {
            return;
        }

        this.injectRecaptchaScript();
        this.injectRecaptchaHTML();
    }

    /**
     * @private
     * @description injects the google recaptcha to the head, only once
     */
    injectRecaptchaScript() {
        const scriptUrl = `https://www.google.com/recaptcha/api.js?render=${this.siteKey}`;
        const scriptId = 'js-google-recaptcha';

        injectScript(scriptUrl, scriptId);
    }

    /**
     * @private
     * @description adds the required input field to the form, but makes
     * sure there is only one of them
     */
    injectRecaptchaHTML() {
        const inputName = 'g-recaptcha-response';

        if (this.formNode.querySelector(`[name=${inputName}]`)) {
            return;
        }

        this.input = document.createElement('input');
        this.input.name = inputName;
        this.input.type = 'hidden';

        this.formNode.appendChild(this.input);
    }

    /**
     * @public
     * @description get a generated recaptcha token
     */
    getRecaptchaToken() {
        return new Promise((resolve, reject) => {
            if (!grecaptcha) {
                reject();
            } else {
                grecaptcha.ready(() => {
                    grecaptcha
                        .execute(this.siteKey, {
                            action: this.actionName || kebabToCamel(this.formNode.dataset.name)
                        })
                        .then(token => resolve(token));
                });
            }
        });
    }

    /**
     * @public
     * @description manual trigger to be placed when all other validation is good
     * @param callback: function(any): any
     */
    submit(callback) {
        this.getRecaptchaToken().then(token => {
            this.input.value = token;
            callback && callback();
        });
    }
}
